import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo, getRouteSeo } from '../lib/seo';

export default function SeoMetadata() {
  const { pathname } = useLocation();
  // Slash variants are the same page; keep metadata added by loaded articles.
  const metadataPath = pathname.replace(/\/+$/, '') || '/';
  useEffect(() => { applySeo(getRouteSeo(metadataPath)); }, [metadataPath]);
  return null;
}
